var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconEmployeeChecklist4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 400 400"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9EDFF",
  d: "M40 170.068a160 160 0 1 0 320 0 160 160 0 1 0-320 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "M76 34.068h184v256H76Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M76 34.068h184v256H76Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M96 54.068h144v216H96Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M96 54.068h144v216H96Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M189.82 27.888a21.82 21.82 0 0 0-43.64 0h-22.544a8 8 0 0 0-8 8v18.18a4 4 0 0 0 4 4h96.728a4 4 0 0 0 4-4v-18.18a8 8 0 0 0-8-8Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M189.82 27.888a21.82 21.82 0 0 0-43.64 0h-22.544a8 8 0 0 0-8 8v18.18a4 4 0 0 0 4 4h96.728a4 4 0 0 0 4-4v-18.18a8 8 0 0 0-8-8Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#B0D9FF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M160 108.22v13.688h-48v-48h35m-35 64.16h47.84v47.84H112zm0 64h47.84v47.84H112z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M140.94 110.896a4.92 4.92 0 0 1-3.368-1.6l-14.6-15.4a5 5 0 0 1 7.26-6.876l11.012 11.62 30.168-31.04a5 5 0 0 1 7.172 6.968l-33.796 34.8a5.04 5.04 0 0 1-3.356 1.508Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#B0D9FF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M188 101.908h36m-36 12h23.144m-23.144 32h27.692m-27.692 12h32.728"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "M223.076 385.288a57.628 8.644 0 1 0 115.256 0 57.628 8.644 0 1 0-115.256 0"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m249.304 279.616 11.416 105.672h39.964L312.1 279.616z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M280.704 302.504v82.78m-31.4-105.668 11.416 105.672h39.964L312.1 279.616z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M280.704 385.284a17.48 17.48 0 0 0-17.48-17.476h-2.912a17.48 17.48 0 0 0-15.144 8.74 5.824 5.824 0 0 0 5.048 8.736Zm0 0a17.476 17.476 0 0 1 17.476-17.476h2.916a17.48 17.48 0 0 1 15.14 8.74 5.824 5.824 0 0 1-5.036 8.736Zm-31.4-105.684 2.74 47.664a4 4 0 0 0 4 3.772h49.52a4 4 0 0 0 4-3.788L312.1 279.6l.104-8.508h-62.8Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "M243.732 205.872 232 189.548a86.07 86.07 0 0 1 48.8-15.496 51.38 51.38 0 0 1 51.384 51.384v5.708h-20v51.38l-25.692 2.856-5.692-17.128-5.708 17.128-25.692-2.856v-54.8c-1.284-10.896-5.668-9.864-5.668-21.852"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M298.056 177.024 280.704 234l-15.36-46.184-3.368-10.164a50.5 50.5 0 0 1 18.84-3.6 49.2 49.2 0 0 1 17.24 2.972"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M280.704 233.996v34.256m31.524-42.84a17.1 17.1 0 0 1 3.02-7.8 17.16 17.16 0 0 0 2.564-9.36m-59.26 5.536 1.028-15.416-11.132.688-.8-12.8a48.7 48.7 0 0 1 14.328-8.624L280.704 234Zm53.664-28.944-.688 10.8-.228 3.484-11.128-.684 1.084 15.412L280.704 234l17.352-56.972a49 49 0 0 1 14.16 7.816"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "m290.06 203.284-9.36-15.804-10.736 14.228"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M232 189.548c-15.024 10.908-28.672 29.484-32.66 61.124a10.05 10.05 0 0 0 8.708 11.22 11 11 0 0 0 1.268.08 10.044 10.044 0 0 0 9.952-8.8c3.116-24.7 13.284-39.02 24.448-47.312Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M243.732 205.872 232 189.548a86.07 86.07 0 0 1 48.8-15.496 51.38 51.38 0 0 1 51.384 51.384v5.708h-20v51.38l-25.692 2.856-5.692-17.128-5.708 17.128-25.692-2.856v-54.8c-1.284-10.896-5.668-9.864-5.668-21.852Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M292.332 273.8a10.184 10.184 0 0 1 3.756-13.252 31.26 31.26 0 0 0 16.14-27.2v-7.92h19.956v7.92a49.62 49.62 0 0 1-26.156 44.444 9.736 9.736 0 0 1-13.696-3.976Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "m268.744 175.52 11.956 11.96 11.964-11.96v-14.892h-23.92z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "m205.46 192.128 69.764 82.508a16.076 16.076 0 0 1-23.652 21.736l-76.34-76.464Zm-72.58-24.216a20.04 20.04 0 0 1-7.344-15.48 44.74 44.74 0 0 0-4.636-21.98 45 45 0 0 0 21.5 6.468 20.03 20.03 0 0 1 14.8 8.624l14.8 21.568-18.892 17.36Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "m158.176 193.764 22.672-20.832 24.612 19.196-30.228 27.78z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "m153.124 184.472 18.892-17.36 8.832 5.82-22.672 20.832z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M132.88 167.912a20.04 20.04 0 0 1-7.344-15.48 44.74 44.74 0 0 0-4.636-21.98 45 45 0 0 0 21.5 6.468 20.03 20.03 0 0 1 14.8 8.624l14.8 21.568-18.892 17.36Zm25.296 25.852 22.672-20.832 24.612 19.196-30.228 27.78z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M139.692 158.484a5.132 5.132 0 1 1 7.252.304 5.13 5.13 0 0 1-7.252-.304"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "m139.996 151.232-17.36-18.892M246 290.78l-3.38 3.112a10.26 10.26 0 0 1-14.176-.276L195.316 260.7"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "m205.46 192.128 69.764 82.508a16.076 16.076 0 0 1-23.652 21.736l-76.34-76.464Z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "m182.492 227.176 29.6-27.204-6.632-7.844-30.228 27.78z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "m205.46 192.128 69.764 82.508a16.076 16.076 0 0 1-23.652 21.736l-76.34-76.464Z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "m205.148 267.688-7.2-7.948a6.084 6.084 0 0 1 0-7.924l4.028-5.016a6.252 6.252 0 0 1 9.44-.652l8.552 9.416a6.252 6.252 0 0 1-1.548 9.336l-5.384 3.552a6.09 6.09 0 0 1-7.888-.764Z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M281.516 169.704a34.24 34.24 0 0 0 28.856-28.444h.028c10.748-1.544 8.96-18.636-.744-17.244l-.976-6.8a34.35 34.35 0 1 0-68 9.772l.976 6.8c-9.704 1.392-6.608 18.3 4.144 16.756h.024a34.24 34.24 0 0 0 35.692 19.16"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#020064",
  d: "M264.104 127.092a4.292 4.292 0 1 0 4.864 3.64 4.29 4.29 0 0 0-4.864-3.64m22.104-3.176a4.292 4.292 0 1 0 4.86 3.64 4.29 4.29 0 0 0-4.86-3.64"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "M260.108 141.548a3.436 3.436 0 1 1-3.888-2.912 3.43 3.43 0 0 1 3.888 2.912m40.804-5.864a3.436 3.436 0 1 1-3.892-2.912 3.436 3.436 0 0 1 3.892 2.912"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M270.132 150.836a15.48 15.48 0 0 0 17-2.444"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M256.604 107.6s15.736-10.912 25.432-3.656l19.388 14.52s9.692 7.24 19.376-5.664l-6.056-2 7.656-6.904s-5.652.8-12.52-6.852-17.78-23.4-37.56-20.556c-28.256 4.056-28.644 21.416-28.644 21.416Z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M256.604 107.6s15.736-10.912 25.432-3.656l19.388 14.52s9.692 7.24 19.376-5.664l-6.056-2 7.656-6.904s-5.652.8-12.52-6.852-17.78-23.4-37.56-20.556c-28.256 4.056-28.644 21.416-28.644 21.416Z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M310.264 139.428a5.708 5.708 0 1 0 11.416 0 5.708 5.708 0 1 0-11.416 0m-76.288 10.96a5.708 5.708 0 1 0 11.416 0 5.708 5.708 0 1 0-11.416 0"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M243.68 97.904s-14.128 2.032-11.692 18.984c2.028 14.128 10.912 15.736 10.912 15.736s3.2-17.768 13.704-25.04Z"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M243.68 97.904s-14.128 2.032-11.692 18.984c2.028 14.128 10.912 15.736 10.912 15.736s3.2-17.768 13.704-25.04Z"
})));
export default SvgStreamlineIconEmployeeChecklist4;